var $120d68a93c8cf8b2$exports = {};
$120d68a93c8cf8b2$exports = {
    "more": `Fler artiklar`
};


export {$120d68a93c8cf8b2$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
